export default {
  id: null,
  usuario: {
    id: null
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/default/empty/emptyCadastroBase.js